<script setup lang="ts">
import Header from '@/components/Header/Header.vue'
import Footer from '@/components/shared/Footer.vue'
import { cn } from '@/lib/utils'
import { useUrlSearchParams } from '@vueuse/core'
import { HTMLAttributes } from 'vue'

const props = defineProps<{ contentClasses?: string; class?: HTMLAttributes['class']; hideFooter?: boolean }>()

const { download_pdf: downloadPdf } = useUrlSearchParams()
</script>
<template>
    <div :class="cn('font-inter relative min-h-dvh overflow-hidden', props.class)">
        <Header v-if="downloadPdf !== 'true'" />
        <div :class="cn('min-h-[65.6vh] py-18 text-slate-800', contentClasses)">
            <slot />
        </div>
        <div></div>

        <Footer v-if="!hideFooter && downloadPdf !== 'true'" />
    </div>
</template>
